import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../components/OverlayLoader';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AuthTypes from './../../redux/constants';
import HttpClient from '../../helpers/HttpClient'; 

import Copyright from '../../components/Copyright';
import { showToast } from '../../utils/toast';

export default function SignIn() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email').trim();
    const password = data.get('password').trim()
    if (email == "" || password == "") {
      showToast("Completa los datos");
    }else{
      setOpen(true);
      const loginRequest = await HttpClient().post(`/token`, {
        email: email,
        password: password
      });
      setOpen(false);
      if (loginRequest.error) {
        showToast("No se pudo validar tus credenciales. Revisa que sean correctas e intenta nuevamente.");
      } else {
        const user = loginRequest.data.user;
        user["token"] = loginRequest.data.token;
        dispatch({
          type: AuthTypes.LOGIN,
          user: loginRequest.data.user
        });
        navigate("/home");
      }

    } 
  };

  return (
      <Container component="main" maxWidth="xs">
        <OverlayLoader open={open} />
       
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          className='login-center'
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Iniciar sesión
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Nombre de usuario / Correo electrónico"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {/*<FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Recordarme"
        />*/}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Ingresar
            </Button>
            <Grid container>
              <Grid item xs>
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    navigate("/recovery")
                  }}
                >
                  Olvidaste tu contraseña?
                </Link>
              </Grid>
              <Grid item>
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    navigate("/register")
                  }}
                >
                  Registrate
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/*<Copyright sx={{ mt: 8, mb: 4 }} />*/}
        {/*<ToastContainer />*/}
      </Container>
  );
}